<template lang='pug' src='./custom-get-virtual.pug'></template>

<script>
import VirtualForm from 'components/forms/virtual-form/virtual-form'
import Title from 'components/block/block-title/block-title'

export default {
  props: ['props'],
  components: {
    Title,
    VirtualForm
  }
}
</script>



// WEBPACK FOOTER //
// custom-get-virtual.vue?19d5dc20